import { Autocomplete, InputLabelProps } from '@mui/material';
import TextField from '@mui/material/TextField';
import { IValueLabelPair } from 'models/Common';
import { InputLabel } from '@mui/material';

interface ISearchableSelect {
    id: string;
    label: string;
    size?: 'small' | 'medium';
    onChange: (value: IValueLabelPair | null) => void;
    value: string | number;
    disabled?: boolean;
    options: IValueLabelPair[];
    inputProps?: any;
    InputProps?: any;
    InputLabelProps?: Partial<InputLabelProps>;
    placeholder?: string;
    fullWidth?: boolean;
    topLabel?: boolean;
}

export const SearchableSelect = ({
    id,
    label,
    size = 'small',
    onChange,
    value,
    disabled = false,
    options,
    inputProps,
    InputProps,
    InputLabelProps,
    placeholder,
    fullWidth = true,
    topLabel,
}: ISearchableSelect) => {
    const selectedOption = options.find((o) => o.value === value) || null;

    return (
        <>
            {topLabel && <InputLabel htmlFor={id}>{label}</InputLabel>}
            <Autocomplete
                id={id}
                options={options}
                value={selectedOption}
                onChange={(_, newValue) => onChange(newValue)}
                getOptionLabel={(option) => option.label ?? ''}
                isOptionEqualToValue={(option, val) => option.value === val.value}
                fullWidth={fullWidth}
                size={size}
                disabled={disabled}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={topLabel ? '' : label}
                        placeholder={placeholder}
                        variant="outlined"
                        multiline
                        InputLabelProps={InputLabelProps}
                        InputProps={{
                            ...params.InputProps,
                            sx: {
                                alignItems: 'flex-start',
                                paddingTop: '8px',
                            },
                            classes: InputProps?.classes,
                            ...InputProps,
                        }}
                        inputProps={{
                            ...params.inputProps,
                            style: {
                                minWidth: '100%',
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                                overflowWrap: 'break-word',
                                overflow: 'visible',
                            },
                            ...inputProps,
                        }}
                    />
                )}
            />
        </>
    );
};
